import { useQuery } from '@tanstack/react-query';
import { getProjectFiles } from '../api/project-file.api';
import type { Core } from '@strapi/types';

export const useProjectFilesInit = ({
	projectId,
	documentType,
	documentName,
	startDate,
	endDate,
}: Core.Helpers.Controllers.GetRequestBody<'api::project-file.project-file', 'getProjectFiles'>) => {
	const {
		data: projectFiles,
		error,
		isLoading,
		refetch,
	} = useQuery({
		queryKey: ['GET_PROJECT_FILES', projectId, documentType, documentName, startDate, endDate],
		queryFn: () => getProjectFiles({ projectId, documentType, documentName, startDate, endDate }),
		enabled: !!projectId,
		refetchOnWindowFocus: true,
	});

	return {
		projectFiles,
		error,
		isLoading,
		refetch,
	};
};
